import { render } from "./App.vue?vue&type=template&id=36f871fc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=36f871fc&lang=scss"

import exportComponent from "D:\\workpace\\yt-portal-layout\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__